import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

/**
 */
class Cart extends BaseApi{
  static getClassName(){ return 'Cart' }

  static cartPreparation(input){
    return app.make("axios").get(`v1/cart-preparation`,{
      params: {
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }
  /**
   */
  static getCartPhotos(input){
    return app.make("axios").get(`v1/cart/${input["cart_id"]}/cart_photo?with_photos=1`,{
      params: {
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static addCartPhoto(input){
    return app.make("axios").post(`v1/cart/${input["cart_id"]}/cart_photo`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static removeCartPhoto(input){
    return app.make("axios").delete(`v1/cart/${input["cart_id"]}/cart_photo/${input["cart_photo_id"]}`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static updateCartPhotoSize(input){
    return app.make("axios").patch(`v1/cart/${input["cart_id"]}/cart_photo/${input["cart_photo_id"]}/photo_size/${input["photo_size_id"]}`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static addCartPhotoPurchaseTarget(input){
    return app.make("axios").post(`v1/cart/${input["cart_id"]}/cart_photo/${input["cart_photo_id"]}/purchase-target`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static removeCartPhotoPurchaseTarget(input){
    return app.make("axios").delete(`v1/cart/${input["cart_id"]}/cart_photo/${input["cart_photo_id"]}/purchase-target`)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static getPurchaseTargetCartPhotos(input){
    return app.make("axios").get(`v1/cart/${input["cart_id"]}/purchase-target?with_photos=1`,{
      params: {
      }
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  static commitOrder(input) {
    return app.make("axios").post(`v1/cart/${input["cart_id"]}/commit-order`, {
      params: {}
    })
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

}
export default Cart



// WEBPACK FOOTER //
// ./src/api/Cart.js